module.exports = __webpack_public_path__ + "static/media/logo.94b28af4.png";